import type { Locale } from '@/i18n/locales'

export interface ReviewNote {
  site: string
  legal: string
}

export const REVIEW_NOTES: Partial<Record<Locale, ReviewNote>> = {
  tr: {
    site: 'Bu sitenin Türkçe metinleri makine çevirisidir; anadili Türkçe olan biri tarafından gözden geçirilmesi bekleniyor.',
    legal:
      'Bu metin Hırvatça ve İngilizce olarak yayımlanmıştır. Türkçe sürüm bilgi amaçlı bir makine çevirisidir ve henüz anadili Türkçe olan biri tarafından gözden geçirilmemiştir; çelişki durumunda Hırvatça ve İngilizce sürümler geçerlidir.',
  },
}

export const reviewNoteFor = (locale: Locale): ReviewNote | undefined => REVIEW_NOTES[locale]
